import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Phone, Linkedin } from 'lucide-react';
import sigaLogo from '../assets/siga-logo.png';
import GoogleReviews from '../components/GoogleReviews';

export default function Footer() {
  return (
    <footer className="bg-forest-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img 
                src={sigaLogo} 
                alt="Siga Imóveis Sob Medida" 
                className="h-10 brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed text-left md:text-justify">
              Na Siga Imóveis Sob Medida, estamos comprometidos em tornar a busca e aquisição de propriedades uma experiência excepcional para nossos clientes. Profissionais que somam 20 anos de experiências e nossa missão é ajudar você a encontrar o lar dos seus sonhos ou investimentos lucrativos.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Navegação</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-jungle-400 transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-gray-300 hover:text-jungle-400 transition-colors text-sm">
                  Sobre
                </Link>
              </li>
              <li>
                <Link to="/corporate" className="text-gray-300 hover:text-jungle-400 transition-colors text-sm">
                  A Empresa
                </Link>
              </li>
              <li>
                <Link to="/anuncie-seu-imovel" className="text-gray-300 hover:text-jungle-400 transition-colors text-sm">
                  Anuncie seu imóvel
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-jungle-400 transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-400 mb-1">Central de vendas WhatsApp</p>
                <a href="tel:+551127382378" className="flex items-center text-gray-300 hover:text-jungle-400 transition-colors">
                  <Phone className="w-4 h-4 mr-2" />
                  <span className="text-sm">(11) 2738-2378</span>
                </a>
                <a href="https://wa.me/5511940708893" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-300 hover:text-jungle-400 transition-colors">
                  <Phone className="w-4 h-4 mr-2" />
                  <span className="text-sm">(11) 94070-8893</span>
                </a>
              </div>
              <div>
                <p className="text-sm text-gray-400 mb-1">São Paulo</p>
                <p className="text-sm text-gray-300">Atendimento em toda região metropolitana</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Redes Sociais</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/sigaimoveissobmedida"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-jungle-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/sigaimoveis/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-jungle-600 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCltTyW0Q4eJ3EpMQ9D6AiZw"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-jungle-600 transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/sigamoveissobmedida/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-jungle-600 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Google Reviews Section */}
        <GoogleReviews />

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-center md:text-left">
            <p className="text-sm text-gray-400">
              © 2025 Siga Imóveis Sob Medida. Todos os direitos reservados.
            </p>
            <p className="text-sm text-gray-400">
              CRECI 025269
            </p>
          </div>
          <Link to="/politica-privacidade" className="text-sm text-gray-400 hover:text-jungle-400 transition-colors">
            Política de Privacidade
          </Link>
        </div>
      </div>
    </footer>
  );
}
